import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { Formik } from 'formik';

import Wrapper from '../../shared/Wrapper';
import DentistrySplash from './DentistrySplash';
import Testimonials2 from '../../shared/Testimonials2';
import Footer from '../../shared/Footer';
import FeaturedCoursesByIndustry from './FeaturedCoursesByIndustry';

import { getNurseOptions } from '../../../fixture/data';
import { withRouter } from 'react-router-dom';
import DentistryBanner from '../../../assets/dentistryBanner.jpg';
import ProfessionalImg from '../../../assets/professional.png';
import dentalCourses from '../../../assets/dentalCourses.jpg';
import dentalHy from '../../../assets/dentalHy.jpg';
import registeredDental from '../../../assets/registeredDental.jpg';
import agd_accred from '../../../assets/agd_accred.png';
import NurseBg from '../../../assets/nurseBg.png';
import { Link } from 'react-router-dom';

import {
  Subtitle,
  Text,
  Container,
  Form,
  StyledRow,
  Label,
  StyledSelect,
  Button,
  Title,
} from '../../theme/index';

const CenterSubtitle = styled(Subtitle)`
  color: ${props => props.color || 'white'};
  text-align: center;
  span {
    color: ${props => props.spanColor || '#ffaf77'};
  }
`;

const Image = styled.img`
  display flex;
  margin: 10px 25px;
  width: auto; 
  @media (max-width: 500px) {
    width: 225px;
}
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1350px) {
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
  }
`;

const AccredidationContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  align-items: center;
  background-size: cover;
  background-position: center;
  width: 40%;
  @media (max-width: 1350px) {
    width: 95%;
    margin: 0 auto;
  }
`;

const CourseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60%;
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  hr {
    margin: 25px auto;
    border: 1px solid #ffaf77;
  }
  @media (max-width: 1350px) {
    width: 95%;
    margin: 0 auto;
    div {
      flex-direction: column;
      align-items: center;
    }
  }
`;

const FeaturedContainer = styled.div`
  text-align: center;
  width: 100%;
  height: 900px;
  background: ${props => props.background};
  background-size: cover;
  background-position: bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 720px) {
    height: 100%;
    padding: 4em 0;
  }
  img {
    margin-bottom: 10px;
  }

  hr {
    margin: 25px 400px;
    border: 1px solid #ffaf77;
  }
`;

const StyledDiv = styled.div`
  margin-top: 10em;
  width: 100%;
  @media (max-width: 720px) {
    margin-top: 22em;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 50%;
  background-color: #ffaf77;
  margin: 0 auto 25px auto;
`;

class Dentistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profession: [{ label: 'Select', value: null }],
    };
  }

  render() {
    const { history = {} } = this.props;
    return (
      <Wrapper>
        <Helmet
          title="AchieveCE | Approved Continuing Education"
          meta={[
            { name: 'description', content: 'Nursing Page for AchieveCE' },
            { property: 'og:type', content: 'website' },
            { property: 'og:title', content: 'Approved Continuing Education' },
            { property: 'og:url', content: 'http://achievece.com/nursing' },
          ]}
        />
        <DentistrySplash img={DentistryBanner} navigate={this.props.history} />
        <Container textalign="center">
          <ImageContainer>
            <AccredidationContainer>
              <img src={ProfessionalImg} alt="Professional icon" height="90" />
              <Title
                professionsub
                style={{ fontSize: '22px', fontWeight: 600 }}
              >
                Accredited and approved
              </Title>
              <Image
                src={agd_accred}
                alt="agency for healthcare"
                style={{ margin: '12px 0' }}
                height="auto"
              />
              <Text>*All dentistry courses accepted in all 50 states</Text>
            </AccredidationContainer>
            <CourseContainer>
              <CenterSubtitle color="black">
                CE FOR THE WHOLE OFFICE
              </CenterSubtitle>
              <Div />
              <div>
                <Link to="/Registered-Dental-Assistant/California">
                  <img
                    src={registeredDental}
                    alt=""
                    height="125px"
                    style={{ margin: '12px' }}
                  />
                </Link>
                <Link to="/Dentist/California">
                  <img
                    src={dentalCourses}
                    alt=""
                    height="125px"
                    style={{ margin: '12px' }}
                  />
                </Link>
                <Link to="/Dental-Hygienist/California">
                  <img
                    src={dentalHy}
                    alt=""
                    height="125px"
                    style={{ margin: '12px' }}
                  />
                </Link>
              </div>
            </CourseContainer>
          </ImageContainer>
        </Container>
        {/* TODO: send the industry name taking from the url */}
        <FeaturedContainer background={`url('${NurseBg}')`}>
          <StyledDiv>
            <CenterSubtitle color="black">FEATURED PRODUCTS</CenterSubtitle>
            <hr />
            <p>We think we may know what you're looking for...</p>
            <FeaturedCoursesByIndustry industryName="dentistry" />
          </StyledDiv>
        </FeaturedContainer>
        <Container background="#15324B">
          <CenterSubtitle color="white" spanColor="white">
            Don't see what you're looking for?{' '}
            <span style={{ textDecoration: 'underline' }}>
              Choose your State and Profession
            </span>{' '}
            here:
          </CenterSubtitle>
          <Formik
            initialValues={{ state: '', profession: '' }}
            onSubmit={values => {
              let state = values.state.label.replace(/\s+/g, '-');
              let profession = values.profession.label.replace(/\s+/g, '-');
              history.push(`${profession}/${state}`);
            }}
            render={({ values, handleBlur, handleSubmit, setFieldValue }) => (
              <Form
                style={{ width: 'auto', paddingBottom: '40px' }}
                onSubmit={handleSubmit}
              >
                <StyledRow>
                  <Label htmlFor="state">
                    <StyledSelect
                      required
                      type="state"
                      id="state"
                      placeholder="State"
                      options={getNurseOptions('state')}
                      onChange={value => {
                        setFieldValue('state', value);
                        this.setState({
                          profession: getNurseOptions('profession', value),
                        });
                      }}
                      onBlur={handleBlur}
                      value={values.state}
                    />
                  </Label>
                  <Label htmlFor="profession">
                    <StyledSelect
                      required
                      type="profession"
                      id="profession"
                      placeholder="Profession"
                      options={this.state.profession}
                      onChange={value => {
                        setFieldValue('profession', value);
                      }}
                      onBlur={handleBlur}
                      value={values.profession}
                    />
                  </Label>
                </StyledRow>
                <Button home type="submit">
                  Find your ce
                </Button>
              </Form>
            )}
          />
        </Container>
        <Testimonials2 />
        {/* <Container
          background="white"
          style={{ textAlign: 'center', paddingTop: '0' }}
        >
          <CenterSubtitle color="black">SIGN UP FOR 10% OFF</CenterSubtitle>
          <p>Yes! It's that easy!</p>
          <p>We're here to make sure that you have</p>
          <p> seamless and enjoyable CE renewal.</p>
          <p>Include your email for updates and discounts.</p>
          <SubscribeEmail submit={() => {}}>
            <input type="text" placeholder="Enter your email" />
            <button type="submit">
              <i class="fas fa-hand-point-right" /> Subscribe
            </button>
          </SubscribeEmail>
        </Container> */}
        <Footer />
      </Wrapper>
    );
  }
}

export default withRouter(Dentistry);



// WEBPACK FOOTER //
// ./src/components/screens/Industry/Dentistry.jsx